export default function Legislation() {
    return (
        <section>
            <h2 id="legislation" data-testid="legislation">
                IX. LEGISLAÇÃO, FORO E ATUALIZAÇÃO
            </h2>
            <p>
                Esta Política será regida, interpretada e executada de acordo
                com as Leis da República Federativa do Brasil, especialmente a
                Lei nº 13.709/2018 - Lei Geral de Proteção de Dados,
                independentemente das Leis de outros estados ou Países, sendo
                competente o foro de domicílio do Usuário para dirimir qualquer
                dúvida decorrente deste documento.
            </p>
            <p>
                Esta Política pode ser atualizada a qualquer momento por razões
                legais, pelo uso de novas tecnologias e funcionalidades e sempre
                que a AMBEV entender que as alterações são necessárias, o que
                será cientificado aos Usuários por meio do App, podendo ainda
                ser encaminhado por e-mail, caso o Usuário tenha optado por
                receber comunicações da AMBEV. Após ciência das modificações
                informadas, ao continuar utilizando o App, o Usuário concorda
                automaticamente com os novos termos da Política e, caso não
                concorde com as alterações, pedimos que deixe de acessar o App.
            </p>
            <p>Atualizado em 27 de novembro de 2024.</p>
        </section>
    );
}
